import { render } from "./carousel.vue?vue&type=template&id=2062a647&scoped=true"
import script from "./carousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./carousel.vue?vue&type=script&setup=true&lang=ts"

import "./carousel.vue?vue&type=style&index=0&id=2062a647&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2062a647"
/* hot reload */
if (module.hot) {
  script.__hmrId = "2062a647"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2062a647', script)) {
    api.reload('2062a647', script)
  }
  
  module.hot.accept("./carousel.vue?vue&type=template&id=2062a647&scoped=true", () => {
    api.rerender('2062a647', render)
  })

}

script.__file = "resources/ts/components/elements/carousel.vue"

export default script